<template>
    <v-card v-if="item"
            class="w-100 flex-column flex-center align-stretch pa-10 mb-5"
            flat>

        <a v-if="item.sum_tv_scheduled"
           class="text-decoration-none"
           href="/sumtv">
            <v-alert
                    icon="tv"
                    prominent
                    class="v-card--hover"
                    text
                    type="info">
                Pratite od 10:00 na RTV Herceg Bosne ili putem SUM TV
            </v-alert>
        </a>

        <h2 v-else-if="item.content_type_id === 2">
            <a :href="item.url" target="_blank">
                {{item.title}}
            </a>
        </h2>

        <h2 v-else-if="item.content_type_id === 3">
            <a :href="storageUrl + item.file_path" target="_blank">
                {{item.title}}
            </a>
        </h2>

        <!-- Embed video -->
        <template v-else-if="[5,6].includes(item.content_type_id)" class="w-100">
            <h2 class="subtitle-1 text-uppercase blue-sumit-color mb-5">{{item.title}}</h2>
            <iframe v-if="getEronetEmbed(item.file_path)" controls class="content-video w-100"
                    frameborder="0" scrolling="no" allowFullScreen :src="getEronetEmbed(item.file_path)">
            </iframe>
            <video v-else-if="getGoogleEmbed(item.url)" class="content-video" width="560px"
                   height="315px" controls>
                <source :src="getGoogleEmbed(item.url)" type="video/mp4">
            </video>
            <iframe v-else-if="getYoutubeEmbed(item.url)" width="560" height="315"
                    :src="getYoutubeEmbed(item.url)" frameborder="0" class="content-video"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen>
            </iframe>
        </template>

        <div v-if="item.authors.length > 0">
            <v-divider v-if="item.authors" class="my-4"></v-divider>
            <p v-if="item.authors.length == 1" class="ma-0 py-1 body-2 text--secondary">Autor:</p>
            <p v-if="item.authors.length > 1" class="ma-0 py-1 body-2 text--secondary">Autori:</p>
            <div v-for="(author, i) in item.authors" :key="i">
                <p v-if="item.authors" class="pa-0 ma-0 body-1 text--primary">{{author.name}} - {{author.school.name}}</p>
            </div>
        </div>
        <div v-else>
            <v-divider v-if="item.author" class="my-4"></v-divider>
            <p v-if="item.author" class="ma-0 py-1 body-2 text--secondary">Autor:</p>
            <p v-if="item.author" class="pa-0 ma-0 body-1 text--primary">{{item.author}}</p>
        </div>
        <v-divider v-if="item.text" class="my-4"></v-divider>
        <p v-if="item.text" class="ma-0 py-1 body-2 text--secondary">Opis:</p>
        <p v-if="item.text" class="pa-0 ma-0 body-1 text--primary">{{item.text}}</p>
    </v-card>
</template>

<script>
    import {storageUrl as storage} from './../.env.js'

    export default {
        name: 'content',
        props: {
            item: {
                type: Object
            }
        },
        data() {
            return {
                storageUrl: storage
            }
        },
        methods: {
            getGoogleEmbed(url) {
                let googleId = this.getVideoId(url, 'drive.google.com', 'id=');
                if (googleId)
                    return 'https://drive.google.com/uc?export=download&id=' + googleId;

                return false;
            },
            getYoutubeEmbed(url) {
                let embed = 'https://www.youtube.com/embed/';

                if (url.includes('youtube.com/embed'))
                    return url;

                let videoId = this.getVideoId(url, 'youtube.com', 'v=');

                if (videoId)
                    return embed + videoId;

                videoId = this.getVideoId(url, 'youtu.be/', 'youtu.be/');

                if (videoId)
                    return embed + videoId;

                return false;
            },
            getVideoId(url, host, point) {
                if (url.includes(host)) {
                    let start = url.indexOf(point);
                    let id = url.substring(start + point.length);
                    return id.split('&')[0];
                }
                return false;
            },
        },
    }
</script>